module.exports = __webpack_public_path__ + "static/media/markdown-html-supported-blog.ab93b649.md";